<template>
  <div class="container">
    <p class="title">Privacy Statement</p>
    <p><strong>Johnson & Johnson Medical (Shanghai) Ltd.</strong>(hereinafter referred to as “J&J” or “we”) is committed to protecting your personal information. This Privacy Statement explains how we process personal information through the SHUYUN（术韵）Platform, which we control and operate.</p><br/>

    <h3>1. Use by Minors</h3>
    <p>SHUYUN（术韵）Platform is not directed to individuals under the age of eighteen (18), and we request that these individuals not provide personal information via SHUYUN（术韵）Platform. If your child has submitted personal information and you would like to request that such personal information be removed, please contact us as explained below under “How to Contact Us and Exercise Your Rights”.</p><br/>

    <h3>2. Personal Information Collection</h3>
    <p>To assist you in completing real-name registration, verify your identity, and provide you with academic activity information and academic content, we will collect and process your following personal information in appropriate means: name, hospital where you work, department of hospital, job title and mobile phone number.</p>
    <p>Additionally, in order to understand your feedback on the content and services provided by the One Surgery Platform, improve service quality, and conduct data analysis, we will collect and process your behavioral data on the One Surgery Platform in appropriate means.</p><br/>

    <h3>3. Personal Information Security</h3>
    <p>We are committed to use reasonable organizational, technical, and administrative measures to protect your personal information from unauthorized or accidental access, destruction, alteration, blocking, copying, dissemination, or other unauthorized processing.</p><br/>

    <h3>4. Retention and Deletion of Personal Information</h3>
    <p>We will retain your personal information for the minimum period necessary to fulfill the purposes stated in this Privacy Statement or as required by applicable laws and regulations.</p>
    <p>Upon expiration of the necessary retention period, unless otherwise stipulated by applicable laws and regulations, or with your consent to continue retention, we will delete or anonymize your personal information.</p><br/>

    <h3>5. Processing of Personal Information by Entrusted Third-Party Vendor(s)</h3>
    <p>To solely fulfill the purposes under this Privacy Statement, we may entrust trustworthy third-party vendor(s) to process your personal information. We are committed to strictly stipulate the personal information processing purpose, scope, duration, means, personal information protection measures, and personal information processing obligations with such third-party vendor(s) via the valid agreements. We shall supervise such third-party vendor(s)’ personal information processing activities and ensure the personal information processing activities performed in a compliant manner.</p><br/>

    <h3>6. How to Contact Us and Exercise Your Rights</h3>  
    <p>If you have questions about this Privacy Statement or you want to exercise your data subject rights (including your right to access, right to copy, data portability right, right to correct and supplement, right to delete, right to restrict the processing, and right to withdraw consent and cancel account), you may contact us via email at chinaprivacy@its.jnj.com or submit your request through the following link:<a href="https://privacyportal.onetrust.com/webform/96f23ee1-34e3-41d6-8d5a-07f0d554152b/3034f16e-7700-486e-98c2-b2cbb05f4cd3?ApplicationName=Shuyun">https://privacyportal.onetrust.com/webform/96f23ee1-34e3-41d6-8d5a-07f0d554152b/3034f16e-7700-486e-98c2-b2cbb05f4cd3?ApplicationName=Shuyun</a>.Unless exceptional circumstances arise, we will respond to your request within 30 days after verifying your identity.</p><br/>

    <p style="text-align: right;">Last Updated: June 2025</p><br/><br/>

    
    <p class="title">Appendix: List of Collected and Processed Personal Information</p><br/>

    <p class="subtitle">1. List of Collected Personal Information</p><br/>
    <div class="table1">
      <div class="tr">
        <div class="td td1">Processing Scenarios</div>
        <div class="td td2">Types of Personal Information</div>
        <div class="td td3">Processing Purposes</div>
      </div>
      <div class="tr">
        <div class="td td1">User registration</div>
        <div class="td td2">name, hospital where you work, department of hospital, job title, and mobile phone number</div>
        <div class="td td3">Complete real-name registration, identity verification; provide academic activity information and academic content</div>
      </div>
      <div class="tr">
        <div class="td td1">User Browsing Data Analysis</div>
        <div class="td td2">behavioral data</div>
        <div class="td td3">Understand user feedback, improve content and service quality, and conduct data analysis</div>
      </div>
    </div><br/>

    <p style="text-align: right;"><span>签署人：{{ user_name }}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>签署时间：{{ privacy_policy_time }}</span></p>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  data() {
    return {
      user_name: '',
      privacy_policy_time: ''
    }
  },
  created() {
    let userInfo = sessionStorage.getItem("userInfo");
    if(userInfo) {
      this.user_name = JSON.parse(userInfo).UserName;
      let privacy_policy_time = JSON.parse(userInfo).privacy_policy_time;
      if(privacy_policy_time) {
        this.privacy_policy_time = privacy_policy_time.includes('T') ? privacy_policy_time.replace('T', ' ') : privacy_policy_time;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  min-height: 100%;
  font-size: 12px;
  padding: 12px;
  box-sizing: border-box;
  background-color: #F8F8F8;
  padding-bottom: 50px;
  .title {
    font-size: 15px;
    text-align: center;
    font-weight: bold;
  }
  .subtitle {
    font-size: 14px;
    font-weight: bold;
  }
  p {
    line-height: 2;
  }
  .ul {
    list-style-type: disc;
    margin-left: 30px;
    li {
      line-height: 2;
    }
  }
  .child_ul {
    list-style-type: circle;
    margin-left: 14px;
    li {
      line-height: 2;
    }
  }
  a {
    color: #1989fa;
  }
  .table1 {
    border: 1px solid #000000;
    .tr {
      display: flex;
      .td { 
        padding: 8px 5px;
      }
      .td1 {
        width: 20%;
        border-right: 1px solid #000000;
      }
      .td2 {
        width: 40%;
        border-right: 1px solid #000000;
      }
      .td3 {
        width: 40%;
      }
    }
    .tr:not(:last-of-type) {
      border-bottom: 1px solid #000000;
    }
    .tr:first-of-type {
      background-color: #dddddd;
    }
  }
  .table2 {
    border: 1px solid #000000;
    .tr {
      display: flex;
      .td { 
        padding: 8px 5px;
      }
      .td1 {
        width: 15%;
        border-right: 1px solid #000000;
      }
      .td2 {
        width: 20%;
        border-right: 1px solid #000000;
      }
      .td3 {
        width: 20%;
        border-right: 1px solid #000000;
      }
      .td4 {
        width: 15%;
        border-right: 1px solid #000000;
      }
      .td5 {
        width: 30%;
      }
    }
    .tr:not(:last-of-type) {
      border-bottom: 1px solid #000000;
    }
    .tr:first-of-type {
      background-color: #dddddd;
    }
  }
}
</style>